var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":"red","label":"","small":"","text-color":"white"}},[_vm._v(" 必須 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }